import React, { useEffect, useState } from "react";
import { Column, MasterDetail, GroupItem, Summary, TotalItem } from "devextreme-react/data-grid";
import { LVGridCarga } from "../../Componentes/Basicos/LVGridCarga";
import { PaginaCarga } from "../../Componentes/Compuestos/Paginas/PaginaCarga";
import { function_VEN_Pedidos_Cabecera_ListarParaFacturarRemitir } from "neftis7_apicaller/src/funciones/VEN/Pedidos/VEN_Pedidos_Cabecera";
import { FormateoFechaPara_yyyyMMdd_HHmmss, ObtieneParametros, TratamientoDeVariableBoolean } from "neftis7_apicaller/src/funciones/Varios";
import { NumberBox } from "devextreme-react";
import { function_STK_ART_Stock_Listar } from "neftis7_apicaller/src/funciones/STK/STK_ART_Stock";
import LVButtonAccion from "../../Componentes/Basicos/LVButtonAccion";
import ComboAbmZonUbicaciones from "../../Componentes/Compuestos/Combos/ComboAbmZonUbicaciones";
import { function_VEN_DocsVenta_Cabecera_Insertar, function_VEN_DocsVenta_Generar_JSON } from "neftis7_apicaller/src/funciones/VEN/DocsVenta/VEN_DocsVenta_Cabecera";
import { function_ABM_IMP_PuntosFiscales_LeerPorTerminal, function_ABM_IMP_PuntosFiscales_ObtenerProximoNumeroPorCodigoPuntoFiscal } from "neftis7_apicaller/src/funciones/ABM/IMP/ABM_IMP_PuntosFiscales";
import { function_INV_Remitos_Cabecera_Insertar, function_INV_Remitos_Generar_JSON } from "neftis7_apicaller/src/funciones/INV/Remitos/INV_Remitos_Cabecera";
import { function_AsignacionDeTerminal } from "../../funciones/Varios";
import { function_ABM_EEX_Clientes_Leer } from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_Clientes";
import { function_ABM_TRA_EmpresasTransporte_Leer } from "neftis7_apicaller/src/funciones/ABM/TRA/ABM_TRA_EmpresasTransporte";
import { function_ABM_EEX_ClientesLocaciones_Leer } from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_ClientesLocaciones";

export const VEN_Pedidos_FacturarRemitir = () => {
  const [data, setData] = useState([])
  const [dataStock, setDataStock] = useState([])
  const [loading, setLoading] = useState(false)
  const [globalUsaArticulosConPresentacion, setGlobalUsaArticulosConPresentacion] = useState(false)
  const [globalUsaArticulosConTamano, setGlobalUsaArticulosConTamano] = useState(false)
  const [globalUsaArticulosConUnidadDeMedida, setGlobalUsaArticulosConUnidadDeMedida] = useState(false)
  const [valoresNumberBox, setValoresNumberBox] = useState({});
  const [resumenArticulos, setResumenArticulos] = useState([]);
  const [codigoUbicacion, setCodigoUbicacion] = useState("");
  const [cierreEnProceso, setCierreEnProceso] = useState(false);


  const getData = async () => {
    setLoading(true)
    try {
      const resultData = await function_VEN_Pedidos_Cabecera_ListarParaFacturarRemitir();
      const resultStock = await function_STK_ART_Stock_Listar()
      setData(resultData.data);
      setDataStock(resultStock.data);
    } catch (error) {
      console.error("Error al obtener los datos:" + error);
    }
    setLoading(false)
  };

  const getDataParametros = async () => {
    try {
      const datosModificadores = await ObtieneParametros();
      setGlobalUsaArticulosConPresentacion(await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConPresentacion))
      setGlobalUsaArticulosConTamano(await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConTamano))
      setGlobalUsaArticulosConUnidadDeMedida(await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConUnidadDeMedida))
    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
  };

  const handleValueChange = (id, nuevoValor) => {
    setValoresNumberBox((prev) => ({ ...prev, [id]: nuevoValor })); // Actualiza el valor del NumberBox según el ID de la fila
  };

  useEffect(() => {
    getData();

    getDataParametros()
  }, []);

  const actualizarResumen = () => {
    // Filtra las filas donde el valor del NumberBox es mayor a 0
    const filasFiltradas = data.filter((fila) => valoresNumberBox[fila.IdItem] > 0);

    // Agrupa las filas filtradas por Código de Artículo, Presentación, Tamaño y Unidad de Medida
    const agrupadas = filasFiltradas.reduce((acc, fila) => {
      const clave = `${fila.CodigoArticulo}-${fila.CodigoPresentacion}-${fila.CodigoTamano}-${fila.CodigoUnidadMedida}`;

      if (!acc[clave]) {
        acc[clave] = { ...fila, CantidadTotal: 0 }; // Crea una entrada nueva si no existe
      }

      acc[clave].CantidadTotal += valoresNumberBox[fila.IdItem]; // Suma las cantidades ingresadas en el NumberBox
      return acc;
    }, {});

    // Añade el stock correspondiente desde dataStock
    const resumenConStock = Object.values(agrupadas).map((item) => {
      const stockEncontrado = dataStock.find(
        (stock) =>
          stock.CodigoArticulo === item.CodigoArticulo &&
          stock.CodigoPresentacion === item.CodigoPresentacion &&
          stock.CodigoTamano === item.CodigoTamano &&
          stock.CodigoUnidadMedida === item.CodigoUnidadMedida
      );

      return {
        ...item,
        Stock: stockEncontrado ? stockEncontrado.CantidadActual : 0, // Asigna el stock encontrado o 0 si no existe
      };
    });

    setResumenArticulos(resumenConStock);
  };

  const generarVenta = async (idTipoDocVenta, idCliente, pedidoObj) => {
    try {
      const tiposDocSinIVA = [41, 42, 43, 71, 72, 73];

      const pedidoConCantidadReemplazada = pedidoObj.map((item) => ({
        ...item,
        Cantidad: item.CantidadFacturar, // Sobrescribir Cantidad con CantidadFacturar
        IdItemPedido: item.IdItem,
        ImporteNetoTotal: (item.CantidadFacturar ?? 0) * (item.ImporteNeto ?? 0),
        ImporteIVA: tiposDocSinIVA.includes(idTipoDocVenta) ? 0 : item.ImporteIVA,
        ImporteIVATotal: tiposDocSinIVA.includes(idTipoDocVenta) ? 0 : (item.CantidadFacturar ?? 0) * (item.ImporteIVA ?? 0),
        ImporteBonificacionesTotal: (item.CantidadFacturar ?? 0) * (item.ImporteDescuentos ?? 0),
        ImporteRecargosTotal: (item.CantidadFacturar ?? 0) * (item.ImporteRecargos ?? 0),
        ImporteSubTotalTotal: ((item.CantidadFacturar ?? 0) * (item.ImporteNeto ?? 0)) +
          ((item.CantidadFacturar ?? 0) * (item.ImporteRecargos ?? 0)) -
          ((item.CantidadFacturar ?? 0) * (item.ImporteDescuentos ?? 0)),
        ImporteImpuestosInternosTotal: (item.CantidadFacturar ?? 0) * (item.ImporteImpuestosInternos ?? 0),
        ImporteTotalTotal: ((item.CantidadFacturar ?? 0) * (item.ImporteNeto ?? 0)) +
          (tiposDocSinIVA.includes(idTipoDocVenta) ? 0 : (item.CantidadFacturar ?? 0) * (item.ImporteIVA ?? 0)) +
          ((item.CantidadFacturar ?? 0) * (item.ImporteRecargos ?? 0)) -
          ((item.CantidadFacturar ?? 0) * (item.ImporteDescuentos ?? 0)) +
          ((item.CantidadFacturar ?? 0) * (item.ImporteImpuestosInternos ?? 0)),
        CodigoUbicacion: codigoUbicacion,
        CodigoUbicacionIngreso: codigoUbicacion,
        CodigoUbicacionEgreso: codigoUbicacion,
      })).filter(item => item.Cantidad > 0);

      if (pedidoConCantidadReemplazada.length === 0) {
        return; // Salir de la función sin continuar
      }

      const PVDV = await function_ABM_IMP_PuntosFiscales_LeerPorTerminal(localStorage.getItem("Terminal"), 4, idTipoDocVenta)

      if (!PVDV.data || PVDV.data.length === 0) {
        throw new Error("No se definió Punto de Venta Fiscal para Documentos de Venta para la Terminal " + localStorage.getItem("Terminal"))
      }

      const ProximoNumeroDV = await function_ABM_IMP_PuntosFiscales_ObtenerProximoNumeroPorCodigoPuntoFiscal(PVDV.data[0].CodigoPuntoFiscal, 4, idTipoDocVenta)

      if (!ProximoNumeroDV.data || ProximoNumeroDV.data.length === 0) {
        throw new Error("No se pudo obtener el Próximo Número de Documentos de Venta")
      }

      const numeroFantasiaDV = ProximoNumeroDV?.data?.NumeroFantasia || '0000-00000000'
      const ptoVtaDV = ProximoNumeroDV?.data?.PtoVta || '0000'
      const numeroDV = ProximoNumeroDV?.data?.Numero || '00000000'

      const JSONFinal = await function_VEN_DocsVenta_Generar_JSON(0, 0, localStorage.getItem("IdPersona"),
        idTipoDocVenta, idCliente, FormateoFechaPara_yyyyMMdd_HHmmss(new Date()), FormateoFechaPara_yyyyMMdd_HHmmss(new Date()),
        FormateoFechaPara_yyyyMMdd_HHmmss(new Date()),
        numeroFantasiaDV, ptoVtaDV, numeroDV,
        "PA", 1, "DO", 0, 0,
        "GENERACIÓN AUTOMÁTICA", "", 0,
        null, 0, "", "", "", 0, 0, null, null,
        pedidoConCantidadReemplazada, [], [], [], [])

      const DocVentaCreado = await function_VEN_DocsVenta_Cabecera_Insertar(JSONFinal, false)
      alert("Se ha creado el DocVenta Nº: " + DocVentaCreado.data.codigoGenerado)
    } catch (error) {
      throw error
    }
  }

  const generarRemito = async (idCliente, pedidoObj, codigoLocacionClienteParam = "") => {
    try {
      const pedidoConCantidadReemplazada = pedidoObj.map((item) => ({
        ...item,
        Cantidad: item.CantidadFacturar, // Sobrescribir Cantidad con CantidadFacturar
        IdItemPedido: item.IdItem,
        ImporteNetoTotal: (item.CantidadFacturar ?? 0) * (item.ImporteNeto ?? 0),
        ImporteIVATotal: (item.CantidadFacturar ?? 0) * (item.ImporteIVA ?? 0),
        ImporteBonificacionesTotal: (item.CantidadFacturar ?? 0) * (item.ImporteDescuentos ?? 0),
        ImporteRecargosTotal: (item.CantidadFacturar ?? 0) * (item.ImporteRecargos ?? 0),
        ImporteSubTotalTotal: ((item.CantidadFacturar ?? 0) * (item.ImporteNeto ?? 0)) +
          ((item.CantidadFacturar ?? 0) * (item.ImporteRecargos ?? 0)) -
          ((item.CantidadFacturar ?? 0) * (item.ImporteDescuentos ?? 0)),
        ImporteImpuestosInternosTotal: (item.CantidadFacturar ?? 0) * (item.ImporteImpuestosInternos ?? 0),
        ImporteTotalTotal: ((item.CantidadFacturar ?? 0) * (item.ImporteNeto ?? 0)) +
          ((item.CantidadFacturar ?? 0) * (item.ImporteIVA ?? 0)) +
          ((item.CantidadFacturar ?? 0) * (item.ImporteRecargos ?? 0)) -
          ((item.CantidadFacturar ?? 0) * (item.ImporteDescuentos ?? 0)) +
          ((item.CantidadFacturar ?? 0) * (item.ImporteImpuestosInternos ?? 0)),
        CodigoUbicacion: codigoUbicacion,
        CodigoUbicacionIngreso: codigoUbicacion,
        CodigoUbicacionEgreso: codigoUbicacion,
      }));

      const PVDV = await function_ABM_IMP_PuntosFiscales_LeerPorTerminal(localStorage.getItem("Terminal"), 16, 1)

      if (!PVDV.data || PVDV.data.length === 0) {
        throw new Error("No se definió Punto de Venta Fiscal para Remitos para la Terminal " + localStorage.getItem("Terminal"))
      }

      const ProximoNumeroDV = await function_ABM_IMP_PuntosFiscales_ObtenerProximoNumeroPorCodigoPuntoFiscal(PVDV.data[0].CodigoPuntoFiscal, 16, 1)

      if (!ProximoNumeroDV.data || ProximoNumeroDV.data.length === 0) {
        throw new Error("No se pudo obtener el Próximo Número de Remito")
      }

      const numeroFantasiaDV = ProximoNumeroDV?.data?.NumeroFantasia || '0000-00000000'
      const ptoVtaDV = ProximoNumeroDV?.data?.PtoVta || '0000'
      const numeroDV = ProximoNumeroDV?.data?.Numero || '00000000'

      let codigoLocacionCliente = codigoLocacionClienteParam || "";
      let codigoEmpresaTransporte = ""
      let codigoEmpresaTransporteLocacion = ""

      if (codigoLocacionCliente == "") {
        const resultCliente = await function_ABM_EEX_Clientes_Leer(idCliente)
        if (resultCliente?.data?.Locaciones?.[0]?.CodigoLocacionCliente) {
          codigoLocacionCliente = resultCliente.data.Locaciones[0].CodigoLocacionCliente || ""
        }
      }

      if (codigoLocacionCliente != "") {
        const resultLocacionCliente = await function_ABM_EEX_ClientesLocaciones_Leer(idCliente, codigoLocacionCliente)

        if (resultLocacionCliente?.data?.[0]?.CodigoEmpresaTransporte) {
          codigoEmpresaTransporte = resultLocacionCliente.data[0].CodigoEmpresaTransporte || ""

          if (resultLocacionCliente?.data?.[0]?.CodigoLocacionEmpresaTransporte) {
            codigoEmpresaTransporteLocacion = resultLocacionCliente.data[0].CodigoLocacionEmpresaTransporte || ""
          }
        }
      }

      const JSONFinal = await function_INV_Remitos_Generar_JSON(0, 1, FormateoFechaPara_yyyyMMdd_HHmmss(new Date()), idCliente,
        numeroFantasiaDV, ptoVtaDV, numeroDV,
        "PA", 1, 0, 0,
        "GENERACIÓN AUTOMÁTICA", "", null, null, false, codigoLocacionCliente, codigoEmpresaTransporte, codigoEmpresaTransporteLocacion, null, null, null, null, null, null, null, null, null,
        null, null, null, null, null, null, null,
        pedidoConCantidadReemplazada, [], [])

      const DocVentaCreado = await function_INV_Remitos_Cabecera_Insertar(JSONFinal)
      alert("Se ha creado el Remito Nº: " + DocVentaCreado.data.codigoGenerado)
    } catch (error) {
      throw error
    }
  }

  const dividirPedido = (pedidoObj) => {
    const pedido1 = [];
    const pedido2 = [];

    pedidoObj.forEach((item) => {
      const cantidadTotal = item.CantidadFacturar;
      const mitadInferior = Math.floor(cantidadTotal / 2); // Mitad redondeada hacia abajo
      const mitadSuperior = cantidadTotal - mitadInferior; // Asegurar que la suma sea igual a la original

      pedido1.push({ ...item, CantidadFacturar: mitadInferior });
      pedido2.push({ ...item, CantidadFacturar: mitadSuperior });
    });

    return [pedido1, pedido2];
  };

  const handleOnClickGuardar = async () => {
    const confirmar = window.confirm("¿Estás seguro de que deseas generar las Facturas y los Remitos para todo lo seleccionado? Esta operación no se puede deshacer y posiblemente generará multiples Documentos de Venta y Remitos");

    if (!confirmar) {
      return; // Si el usuario cancela, no se genera nada
    }

    if (!codigoUbicacion || codigoUbicacion === "") {
      alert("No se definió la Ubicación desde donde saldrán los artículos.")
      return
    }

    const PVR = await function_ABM_IMP_PuntosFiscales_LeerPorTerminal(localStorage.getItem("Terminal"), 16, 1)

    if (!PVR.data || PVR.data.length === 0) {
      alert("No se definió Punto de Venta Fiscal para Remitos para la Terminal " + localStorage.getItem("Terminal"))
      return
    }

    const PVDV1 = await function_ABM_IMP_PuntosFiscales_LeerPorTerminal(localStorage.getItem("Terminal"), 4, 1)

    if (!PVDV1.data || PVDV1.data.length === 0) {
      alert("No se definió Punto de Venta Fiscal para Documentos de Venta FA para la Terminal " + localStorage.getItem("Terminal"))
      return
    }

    const PVDV11 = await function_ABM_IMP_PuntosFiscales_LeerPorTerminal(localStorage.getItem("Terminal"), 4, 11)

    if (!PVDV11.data || PVDV11.data.length === 0) {
      alert("No se definió Punto de Venta Fiscal para Documentos de Venta FB para la Terminal " + localStorage.getItem("Terminal"))
      return
    }

    const PVDV41 = await function_ABM_IMP_PuntosFiscales_LeerPorTerminal(localStorage.getItem("Terminal"), 4, 41)

    if (!PVDV41.data || PVDV41.data.length === 0) {
      alert("No se definió Punto de Venta Fiscal para Documentos de Venta Tipo Manual para la Terminal " + localStorage.getItem("Terminal"))
      return
    }

    // Filtrar registros donde el NumberBox sea mayor a 0
    const registrosFiltrados = data.filter((fila) => valoresNumberBox[fila.IdItem] > 0);

    // Agrupar los registros filtrados por IdPedido
    const pedidosAgrupados = registrosFiltrados.reduce((acc, fila) => {
      if (!acc[fila.IdPedido]) {
        acc[fila.IdPedido] = [];
      }
      acc[fila.IdPedido].push({
        ...fila,
        CantidadFacturar: valoresNumberBox[fila.IdItem] // Incluir la cantidad ingresada en el NumberBox
      });
      return acc;
    }, {});

    // Generar JSON por cada IdPedido
    for (const idPedido of Object.keys(pedidosAgrupados)) {
      try {
        if (cierreEnProceso) return; // si ya está ejecutando, no hace nada
        setCierreEnProceso(true);

        const jsonPedido = JSON.stringify(pedidosAgrupados[idPedido]);
        const pedidoObj = JSON.parse(jsonPedido);
        const idCliente = pedidoObj[0]?.IdCliente;
        const idTipoDocVenta = pedidoObj[0]?.IdTipoDocVenta;

        if (!idCliente || idCliente === 0 || idCliente === null) {
          throw new Error("No se definió el Cliente para el Pedido Nº" + idPedido)
        }

        if (!idTipoDocVenta || idTipoDocVenta === 0 || idTipoDocVenta === null) {
          throw new Error("No se definió el Tipo de Documento de Venta para el Pedido Nº" + idPedido)
        }

        if (idTipoDocVenta === 1141) {
          const [pedidoDividido1, pedidoDividido2] = dividirPedido(pedidoObj);

          await generarVenta(1, idCliente, pedidoDividido1)

          await generarVenta(41, idCliente, pedidoDividido2)

        } else {
          await generarVenta(idTipoDocVenta, idCliente, pedidoObj)
        }

        const codigoLocacionDesdePedido = pedidoObj[0]?.CodigoLocacion || "";
        await generarRemito(idCliente, pedidoObj, codigoLocacionDesdePedido);

      } catch (error) {
        alert(`Error al procesar el pedido ${idPedido}: ${error}`);
      } finally {
        setCierreEnProceso(false); // Se habilita el botón de nuevo
      }
    };

    alert('Se han generado los Documentos de Venta y los Remitos.')
    window.location.reload()
  };

  useEffect(() => {
    actualizarResumen();
  }, [valoresNumberBox, data]);

  useEffect(() => {
    //CHEQUEO DE TERMINAL
    const ControlDeTerminal = async () => {
      let Terminal = localStorage.getItem("Terminal")
      await function_AsignacionDeTerminal(Terminal, true)

      while (Terminal < 1 || !Terminal) {
        try {
          Terminal = await function_AsignacionDeTerminal(prompt("Por favor, ingrese el número de Terminal:"))
          window.location.reload()
        } catch (error) {
          alert(error)
        }
      }
    }
    ControlDeTerminal()
  }, []);

  return (
    <PaginaCarga
      Titulo="PEDIDOS PARA FACTURAR / REMITIR"
    >
      {loading && (
        <div className="spinner-overlay">
          <div className="card-body text-center">
            <div className="spinner-border" role="status">
              <span className="sr-only">Cargando...</span>
            </div>
          </div>
        </div>
      )}

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '10px', marginBottom: '30px', gap: '20px', textAlign: 'center' }}>
        <LVButtonAccion
          Disabled={cierreEnProceso} Texto={"GENERAR FACTURAS Y REMITOS (ESTE PROCESO NO SE PODRA DESHACER)"} onClick={handleOnClickGuardar} />

        <div style={{ width: '100px' }}>

        </div>

        UBICACIÓN DESDE DONDE SALDRÁN LOS ARTÍCULOS PARA GENERAR EL REMITO
        <ComboAbmZonUbicaciones
          onValueChanged={(e) => setCodigoUbicacion(e.value)}
          value={codigoUbicacion}
          ancho="300" />
      </div>

      <div className="table-responsive">
        <div style={{ display: 'flex', gap: '20px' }}>
          <div style={{ alignItems: 'left', marginTop: '10px', marginBottom: '10px', gap: '20px' }}>
          </div>
          {data.length > 0 ? (
            <>
              <LVGridCarga
                dataSource={data}
                id="gridContainer"
                keyExpr="IdItem"
                allowDeleting={false}
                filterRow={true}
              >
                <Summary>
                  <TotalItem
                    column="IdPedido"
                    summaryType="count"
                    customizeText={summaryItem => `Registros: ${summaryItem.value}`} />
                  <TotalItem
                    column="ImporteNeto"
                    summaryType="sum"
                    customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                    valueFormat="currency" />
                  <TotalItem
                    column="ImporteDescuentos"
                    summaryType="sum"
                    customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                    valueFormat="currency" />
                  <TotalItem
                    column="ImporteRecargos"
                    summaryType="sum"
                    customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                    valueFormat="currency" />
                  <TotalItem
                    column="ImporteTotal"
                    summaryType="sum"
                    customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                    valueFormat="currency"
                    displayFormat="currency" />
                  <TotalItem
                    column="Peso"
                    summaryType="sum"
                    customizeText={summaryItem => `${summaryItem.value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                    valueFormat="number" />

                  <GroupItem
                    column="IdPedido"
                    summaryType="count"
                    customizeText={summaryItem => `Registros: ${summaryItem.value}`}
                    showInGroupFooter={true} />
                  <GroupItem
                    column="ImporteNeto"
                    summaryType="sum"
                    customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                    valueFormat="currency"
                    showInGroupFooter={true} />
                  <GroupItem
                    column="ImporteDescuentos"
                    summaryType="sum"
                    customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                    valueFormat="currency"
                    showInGroupFooter={true} />
                  <GroupItem
                    column="ImporteRecargos"
                    summaryType="sum"
                    customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                    valueFormat="currency"
                    showInGroupFooter={true} />
                  <GroupItem
                    column="ImporteTotal"
                    summaryType="sum"
                    customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                    valueFormat="currency"
                    displayFormat="currency"
                    showInGroupFooter={true} />
                  <GroupItem
                    column="Peso"
                    summaryType="sum"
                    customizeText={summaryItem => `${summaryItem.value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                    valueFormat="number"
                    showInGroupFooter={true} />
                </Summary>

                <Column caption="Código" dataField="IdItem" width="70" alignment="Right" dataType="number" />
                <Column caption="Pedido" dataField="IdPedido" width="70" alignment="Right" dataType="number" />
                <Column caption="Fecha" dataField="Fecha" width="100" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} />
                <Column caption="Razón Social" dataField="RazonSocial" width="100%" minWidth={150} alignment="Left" dataType="string" />

                <Column caption="Cantidades" alignment="Center">
                  <Column caption="Pedida" dataField="CantidadPedida" width="70" alignment="Right" dataType="number" />
                  <Column caption="Por Facturar/Remitir" dataField="Cantidad" width="140" alignment="Right" dataType="number" />
                  <Column caption="Fact./Rem." width="100" alignment="Right" dataType="number"
                    cellRender={(data) => (
                      <NumberBox
                        value={valoresNumberBox[data.data.IdItem] || 0}
                        onValueChanged={(e) => handleValueChange(data.data.IdItem, e.value)}
                        onFocusIn={(e) => {
                          const cantidadPorFacturar = data.data.Cantidad; // Accede al valor de la columna "Por Facturar/Remitir"
                          e.component.option("value", cantidadPorFacturar); // Copia el valor al NumberBox
                        }}
                        elementAttr={{ class: "dx-theme-accent-as-background-color" }}
                      />
                    )}
                  />
                </Column>

                <Column caption="Artículo" alignment="Center">
                  <Column caption="Código" dataField="CodigoArticulo" width="100" alignment="Left" dataType="string" />
                  <Column caption="Descripción" dataField="Observaciones" width="200" alignment="Left" dataType="string" />
                </Column>
                <Column caption="Presentación" alignment="Center" visible={globalUsaArticulosConPresentacion}>
                  <Column caption="Código" dataField="CodigoPresentacion" width="70" alignment="Left" dataType="string" />
                  <Column caption="Descripción" dataField="Presentacion" width="100" alignment="Left" dataType="string" />
                </Column>
                <Column caption="Tamaño" alignment="Center" visible={globalUsaArticulosConTamano}>
                  <Column caption="Código" dataField="CodigoTamano" width="70" alignment="Left" dataType="string" />
                  <Column caption="Descripción" dataField="Tamano" width="100" alignment="Left" dataType="string" />
                </Column>
                <Column caption="Unidad de Medida" alignment="Center" visible={globalUsaArticulosConUnidadDeMedida}>
                  <Column caption="Código" dataField="CodigoUnidadMedida" width="70" alignment="Left" dataType="string" />
                  <Column caption="Descripción" dataField="UnidadMedida" width="100" alignment="Left" dataType="string" />
                </Column>

                <Column caption="Importes" alignment="Center">
                  <Column caption="Neto" dataField="ImporteNeto" width="80" alignment="Right" dataType="number" format="currency" />
                  <Column caption="Descuentos" dataField="ImporteDescuentos" width="80" alignment="Right" dataType="number" format="currency" />
                  <Column caption="Recargos" dataField="ImporteRecargos" width="80" alignment="Right" dataType="number" format="currency" />
                  <Column caption="Total" dataField="ImporteTotal" width="100" alignment="Right" dataType="number" format="currency" />
                </Column>

                <Column caption="Planta" dataField="CodigoPlanta" width="80" alignment="Left" dataType="string" visible={false} />
                <Column caption="Peso" dataField="I_PesoTotal" width="70" alignment="Right" dataType="number" visible={false} />
                <Column caption="D.V." dataField="IdTipoDocVenta" width="60" alignment="Right" dataType="number" />
              </LVGridCarga>

              <LVGridCarga
                dataSource={resumenArticulos}
                id="gridResumen"
                keyExpr="CodigoArticulo"
                allowDeleting={false}
                Ancho
              >
                <Column caption="Código" dataField="CodigoArticulo" width="100"
                  cellRender={(data) => (
                    <span style={{ color: data.data.CantidadTotal > data.data.Stock ? 'red' : 'inherit' }}>
                      {data.value}
                    </span>
                  )}
                />
                <Column caption="Presentación" dataField="CodigoPresentacion" width="80" visible={globalUsaArticulosConPresentacion}
                  cellRender={(data) => (
                    <span style={{ color: data.data.CantidadTotal > data.data.Stock ? 'red' : 'inherit' }}>
                      {data.value}
                    </span>
                  )}
                />
                <Column caption="Tamaño" dataField="CodigoTamano" width="80" visible={globalUsaArticulosConTamano}
                  cellRender={(data) => (
                    <span style={{ color: data.data.CantidadTotal > data.data.Stock ? 'red' : 'inherit' }}>
                      {data.value}
                    </span>
                  )}
                />
                <Column caption="U.M." dataField="CodigoUnidadMedida" width="80" visible={globalUsaArticulosConUnidadDeMedida}
                  cellRender={(data) => (
                    <span style={{ color: data.data.CantidadTotal > data.data.Stock ? 'red' : 'inherit' }}>
                      {data.value}
                    </span>
                  )}
                />
                <Column caption="A Facturar" dataField="CantidadTotal" width="70" alignment="right"
                  cellRender={(data) => (
                    <span style={{ color: data.data.CantidadTotal > data.data.Stock ? 'red' : 'inherit' }}>
                      {data.value}
                    </span>
                  )}
                />
                <Column caption="Stock" dataField="Stock" width="70" alignment="right"
                  cellRender={(data) => (
                    <span style={{ color: data.data.CantidadTotal > data.data.Stock ? 'red' : 'inherit' }}>
                      {data.value}
                    </span>
                  )}
                />
              </LVGridCarga>
            </>
          ) : (
            <div className="card-body text-center">
              <h5 className="card-title">No hay datos</h5>
            </div>
          )}
        </div>
      </div>
    </PaginaCarga>
  );
};
